$(document).ready(function () {

 $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {

   quickView();

 });

});

 function cycupdatecart(){
fetch(`${routes.cart_url}?sections=cart-drawer`)
    .then((response) => response.json())
    .then((sections) => {
      const sectionIds = ['cart-drawer'];
      for (const sectionId of sectionIds) {
        const htmlString = sections[sectionId];
        const html = new DOMParser().parseFromString(htmlString, 'text/html');
        const sourceElement = html.querySelector(`${sectionId}`);
        const targetElement = document.querySelector(`${sectionId}`);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      }
      document.body.classList.add('overflow-hidden');
      const theme_cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (theme_cart && theme_cart.classList.contains('is-empty')) theme_cart.classList.remove('is-empty');
      theme_cart.classList.add('active');
    })
    .catch((e) => {
      console.error('Error updating cart sections:', e);
    });
  fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    $('.cart-count-bubble').html('<span aria-hidden="true">'+ cart.item_count +'</span>');
  });

}

function quickView() {

 $(".quick-view").click(function () {

   if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}

   var product_handle = $(this).data('handle');
   var qvproduct_id = $(this).data('productid');
   $('#quick-view').addClass(product_handle);

   jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
     //console.log(product); 
     var title = product.title;

     var type = product.vendor + ' - ' + product.type;

     var price = 0;

     var original_price = 0;

     var desc = product.description;

     var images = product.images;

     var variants = product.variants;

     var options = product.options;

     var url = '/products/' + product_handle;

     $('.qv-product-title').text(title);

     $('.qv-product-type').text(type);

     $('.qv-product-description').html(desc);

     $('.view-product').attr('href', url);
     $('#quickviewvarid').attr('value', product.variants[0].id);
     

     var imageCount = $(images).length;

     $(images).each(function (i, image) {

       if (i == imageCount - 1) {

         var image_embed = '<div><img src="' + image + '"></div>';

         image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');

         $('.qv-product-images').append(image_embed);

         $('.qv-product-images').slick({
           'dots': true,
            customPaging: function(slider, i) {
              return '<button class="custom-dot">' + (i + 1) + '</button>';
            },
           'arrows': true,
           'respondTo': 'min',
           prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M169.4 297.4C156.9 309.9 156.9 330.2 169.4 342.7L361.4 534.7C373.9 547.2 394.2 547.2 406.7 534.7C419.2 522.2 419.2 501.9 406.7 489.4L237.3 320L406.6 150.6C419.1 138.1 419.1 117.8 406.6 105.3C394.1 92.8 373.8 92.8 361.3 105.3L169.3 297.3z"/></svg></button>',
           nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M471.1 297.4C483.6 309.9 483.6 330.2 471.1 342.7L279.1 534.7C266.6 547.2 246.3 547.2 233.8 534.7C221.3 522.2 221.3 501.9 233.8 489.4L403.2 320L233.9 150.6C221.4 138.1 221.4 117.8 233.9 105.3C246.4 92.8 266.7 92.8 279.2 105.3L471.2 297.3z"/></svg></button>',
           'useTransform': false
         }).css('opacity', '1');

       } else {
         image_embed = '<div><img src="' + image + '"></div>';
         image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
         $('.qv-product-images').append(image_embed);
       }

     });

     $(options).each(function (i, option) {

       var opt = option.name;

       var selectClass = '.option.' + opt.toLowerCase();

       $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');

       $(option.values).each(function (i, value) {

         $('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' + value + '</option>');

       });

     });

     $(product.variants).each(function (i, v) {

       if (v.inventory_quantity == 0) {

         $('.qv-add-button').prop('disabled', true).val('Sold Out');

         $('.qv-add-to-cart').hide();

         $('.qv-product-price').text('Sold Out').show();

         return true

       } else {

         price = parseFloat(v.price / 100).toFixed(2);

         original_price = parseFloat(v.compare_at_price / 100).toFixed(2);

         $('.qv-product-price').text('$' + price);

         if (original_price > 0) {

           $('.qv-product-original-price').text('$' + original_price).show();

         } else {

           $('.qv-product-original-price').hide();

         }

         $('select.option-0').val(v.option1);

         $('select.option-1').val(v.option2);

         $('select.option-2').val(v.option3);

         return false

       }

     });
     
    var qvbaseprice = $(".cycprice-container"+qvproduct_id).find('.price-item--sale').data('cycbaseprice');
    var qvdisprice = $(".cycprice-container"+qvproduct_id).find('.price-item--sale').text().trim();
    var qvdishtml = $(".cycprice-container"+qvproduct_id).find('.regios-dopp-description').prop('outerHTML');
    console.log(qvproduct_id);
    console.log(qvbaseprice);
    console.log(qvdisprice);
    console.log(qvdishtml);
    if(qvbaseprice != qvdisprice){
       $('.qv-product-price').html(qvdisprice); 
       $('.qv-product-original-price').html(qvbaseprice).show();
       if(qvdishtml != ''){
         $('.qv-product-price').after(qvdishtml); 
       }
    }
  
   });

 

   $(document).on("change", "#quick-view select", function () {

     var selectedOptions = '';

     $('#quick-view select').each(function (i) {

       if (selectedOptions == '') {

         selectedOptions = $(this).val();

       } else {

         selectedOptions = selectedOptions + ' / ' + $(this).val();

       }

     });

     jQuery.getJSON('/products/' + product_handle + '.js', function (product) {

       $(product.variants).each(function (i, v) {

         if (v.title == selectedOptions) {

           var price = parseFloat(v.price / 100).toFixed(2);

           var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);

           var v_qty = v.inventory_quantity;

           var v_inv = v.inventory_management;

           $('.qv-product-price').text('$' + price);

           $('.qv-product-original-price').text('$' + original_price);

           if (v_inv == null) {

             $('.qv-add-button').prop('disabled', false).val('Add to Cart');

           } else {

             if (v.inventory_quantity < 1) {

               $('.qv-add-button').prop('disabled', true).val('Sold Out');

             } else {

               $('.qv-add-button').prop('disabled', false).val('Add to Cart');

             }

           }

         }

       });

     });

   });

   $.fancybox({
     href: '#quick-view',
     maxWidth: 1040,
     maxHeight: 600,
     fitToView: true,
     width: '95%',
     height: '70%',
     autoSize: false,
     closeClick: false,
     openEffect: 'none',
     closeEffect: 'none',
     'beforeLoad': function () {
       var product_handle = $('#quick-view').attr('class');
       $(document).on("click", ".qv-add-button", function () {
         var qty = $('.qv-quantity').val();
         var selectedOptions = '';
         var var_id = '';
         $('#quick-view select').each(function (i) {

           if (selectedOptions == '') {

             selectedOptions = $(this).val();

           } else {

             selectedOptions = selectedOptions + ' / ' + $(this).val();

           }

         });

         jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
           $(product.variants).each(function (i, v) {
             if (v.title == selectedOptions) {
               var_id = v.id;
               processCart();
             }
           });
         });

         function processCart() {

           jQuery.post('/cart/add.js', {
             quantity: qty,
             id: var_id
           },
                       null,
                       "json"
                      ).done(function () {
             $('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');
             cycupdatecart();
           })
           .fail(function ($xhr) {
             var data = $xhr.responseJSON;
             $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
           });
         }
       });
       $('.fancybox-wrap').css('overflow', 'hidden !important');
     },
     'afterShow': function () {
       $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
         $('.qv-product-images').addClass('loaded');
       });
     },
     'afterClose': function () {
       $('#quick-view').removeClass().empty();
     }

   });

 });

};

$(document).on("click", ".cyc-bc-add-button", function () {
  
   var cychandle = $(this).data("handle");
   var cycid = $(this).data("id");
   var cycqtyclass = '.cyc-bc-' + cycid;
   var cycshipmsgclass = '.cycp-bc-item-shipmessage-' + cycid;
   var cycguardclass = '.cycp-bc-item-guard-' + cycid;
   var qty = $(cycqtyclass).val();
   var var_id = $(this).data("varid");
    //console.log('cyctest: ' + $(this).data("id") + ' var:' + var_id);
   var shipnote = $(cycshipmsgclass).val();
   var guardin = $(cycguardclass).val();
   //console.log('shipmsg:' + shipnote + ' | guardin' + guardin);
    jQuery.getJSON('/products/' + cychandle + '.js', function (product) {
        processCart();
    });
    function processCart() {
           let data = {
           quantity: qty,
            id: var_id
            };
            if (shipnote || guardin == '1') {
               data.properties = {};
              if (guardin == '1') {
                  data.properties["Guardian"] = "Free protection plan included";
               }
               if (shipnote) {
                data.properties["Shipping"] = shipnote;
               }
             }

           jQuery.post('/cart/add.js',data,null,"json")
                      .done(function () {
             cycupdatecart();
           })
           .fail(function ($xhr) {
             var data = $xhr.responseJSON;
             //$('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
           });
         }

});

$(window).resize(function () {
 if ($('#quick-view').is(':visible')) {
   $('.qv-product-images').slick('setPosition');
 }
});

